import { c as _c } from "react/compiler-runtime";
import { cn } from '@/lib/utils';
import { cva, VariantProps } from 'class-variance-authority';
const loaderVariants = cva('size-6 animate-[spin_0.5s_linear_infinite] rounded-full border-2', {
  variants: {
    variant: {
      default: 'border-vive-border-focus border-t-transparent',
      process: 'border-gray-300 border-t-gray-500'
    },
    size: {
      default: 'size-6',
      sm: 'size-5',
      xs: 'size-4'
    }
  },
  defaultVariants: {
    variant: 'default',
    size: 'default'
  }
});
type LoaderProps = {
  className?: string;
  variant?: VariantProps<typeof loaderVariants>['variant'];
  size?: VariantProps<typeof loaderVariants>['size'];
};
function Loader(t0) {
  const $ = _c(6);
  const {
    className,
    variant,
    size
  } = t0;
  let t1;
  if ($[0] !== className || $[1] !== size || $[2] !== variant) {
    t1 = cn(loaderVariants({
      className,
      variant,
      size
    }));
    $[0] = className;
    $[1] = size;
    $[2] = variant;
    $[3] = t1;
  } else {
    t1 = $[3];
  }
  let t2;
  if ($[4] !== t1) {
    t2 = <div className={t1} />;
    $[4] = t1;
    $[5] = t2;
  } else {
    t2 = $[5];
  }
  return t2;
}
export default Loader;